import { render, staticRenderFns } from "./PrintCorpHome.vue?vue&type=template&id=023b4634&scoped=true&"
import script from "./PrintCorpHome.vue?vue&type=script&lang=js&"
export * from "./PrintCorpHome.vue?vue&type=script&lang=js&"
import style0 from "./PrintCorpHome.vue?vue&type=style&index=0&id=023b4634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b4634",
  null
  
)

export default component.exports